module.exports = __webpack_public_path__ + "img/edit.feb62e63.svg";